import {Component, OnInit} from '@angular/core';
import {GatewayReportService} from './gateway-report.service';
import { ActivatedRoute } from '@angular/router';
import * as Highcharts from 'highcharts';
import HichartsExporting from 'highcharts/modules/exporting.src';
import HichartsExportingCSV from 'highcharts/modules/export-data.src';


HichartsExporting(Highcharts);
HichartsExportingCSV(Highcharts);

@Component({
  selector: 'app-reports',
  templateUrl: './gateway-report.component.html',
  styleUrls: ['./gateway-report.component.scss']
})
export class GatewayReportComponent implements OnInit {

  gatewayId: string;
  title = 'Reports';
  options: Object;
  reportStart: number;
  reportEnd: number;
  graphType = 'spline';
  gatewayStatistics: any;
  gatewayDataAvailable = true;
  reportDate = '2018-05';

  constructor(public route: ActivatedRoute, private reportService: GatewayReportService) {
  }

  ngOnInit() {
    
    this.reportEnd = Date.now();
    this.reportStart = Date.now() - 604800000; //7 days   
 
    this.gatewayId = this.route.snapshot.params.gatewayId;
    this.createGraph();
  }

  public onInput(yearMonth: Date): void {

    
    this.reportEnd = Date.now();
    
    
    this.reportStart = Date.now() - 604800000; //7 days
    this.createGraph();
  }
  
  changeGraph(newGraphType: string) {
    this.graphType = newGraphType;
    this.displayGraphs();
  }

  createGraph() {
    
    let reportRequest = {
      gateway_id: this.gatewayId,
      start_timestamp: this.reportStart,
      end_timestamp: this.reportEnd 
    }
        
    this.reportService.getGatewayPings(reportRequest)
      .then(gatewayStasticsResult => {
        
        this.gatewayStatistics = gatewayStasticsResult;
        if (gatewayStasticsResult.length !== 0 ) {
            this.gatewayDataAvailable = true;
            this.displayGraphs();
        } else {
            this.gatewayDataAvailable = false;
        }
      })
  }
  
  private displayGraphs() {
    this.gatewayGraph(this.graphType);
  }

  private gatewayGraph(graphType) {

    let xAxis = [];
    let series = [];
    let javaMemoryFreeData = [];
    let javaTotalMemoryData = [];
    let javaUsedMemoryData = [];
    let osMemoryFreeData = [];
    let osMemoryAvailableData = [];
    let osTotalMemoryData = [];
    let cpuTemperatureData = [];    
    let wLanLevelData = [];
    let wLanLinkData = [];
    let wLanNoiseData = [];
    let threadCount = [];
    

    for (let stat of this.gatewayStatistics) {
      let date = new Date(stat.timestamp);

      xAxis.push(date);
      javaMemoryFreeData.push(stat.data.javaFreeMemoryMB);
      osMemoryFreeData.push(stat.data.osFreeMemoryMB);
      cpuTemperatureData.push(stat.data.cpuTemperature);
      javaTotalMemoryData.push(stat.data.javaTotalMemoryMB);
      javaUsedMemoryData.push(stat.data.javaUsedMemoryMB);
      osMemoryAvailableData.push(stat.data.osMemoryAvailableMB);
      osTotalMemoryData.push(stat.data.osTotalMemoryMB);
      wLanLevelData.push(stat.data.wLanLevel);
      wLanLinkData.push(stat.data.wLanLink);
      wLanNoiseData.push(stat.data.wLanNoise);
      threadCount.push(stat.data.threadCount);
    }

    series.push({
      name: 'java free memory',
      data: javaMemoryFreeData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'OS free memory',
      data: osMemoryFreeData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'CPU Temperature',
      data: cpuTemperatureData,
      tooltip: {
        valueSuffix: ' %'
      },
    });

    series.push({
      name: 'Java Total Memory',
      data: javaTotalMemoryData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'Java Used Memory',
      data: javaUsedMemoryData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'OS Available Memory',
      data: osMemoryAvailableData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'OS Total memory',
      data: osTotalMemoryData,
      tooltip: {
        valueSuffix: ' MB'
      },
    });

    series.push({
      name: 'wLan Level',
      data: wLanLevelData,
      tooltip: {
        valueSuffix: ''
      },
    });

    series.push({
      name: 'wLan Link',
      data: wLanLinkData,
      tooltip: {
        valueSuffix: ''
      },
    });

    series.push({
      name: 'wLan Noise',
      data: wLanNoiseData,
      tooltip: {
        valueSuffix: ''
      },
    });

    series.push({
      name: 'Thread Count',
      data: threadCount,
      tooltip: {
        valueSuffix: ''
      },
    });


    this.options = {
      chart: {
        type: graphType
      },
      title: {
        text: 'Gateway Statistics'
      },
      subtitle: {
        text: 'Awesome Gateway Stats subtitle....'
      },
      xAxis: {
        type: 'datetime',
        categories: xAxis,
        title: {
          text: 'Date'
        }
      },
      yAxis: [{
        min: -300,
        title: {
          text: 'MB',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      }, {
        min: 0,
        title: {
          text: 'CPU%',
          align: 'high'
        },
        labels: {
          overflow: 'justify'
        }
      }],
      credits: {
        enabled: false
      },
      series: series,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        fallbackToExportServer: false,

        buttons: {
          contextButton: {
            menuItems: ['printChart', 'downloadPNG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      rangeSelector: {
        inputPosition: {
          align: 'left',
          x: 0,
          y: 0
        },
        buttonPosition: {
          align: 'right',
          x: 0,
          y: 0
        },
      },
    };

    Highcharts.chart('memory', this.options);
  }

  
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/reports/gateway-report.component.ts